<div class="post-container mt-3 h-100">
  <app-loading *ngIf="postLoading$ | async"></app-loading>
  <div *ngIf="videos && videos.length > 0">
    <app-vjs-player
      *ngFor="let video of videos"
      [options]="{
        autoplay: false,
        sources: [{ src: video.href, type: video.type }],
      }"
    ></app-vjs-player>
  </div>
  <div *ngIf="(!videos || videos.length === 0) && !(postLoading$ | async)">
    {{ "post-video.message.no-videos-available" | translate }}
  </div>
</div>
